export const DATA_ELEM_ICON = 'DescriptionIcon';
